import { useMutation, useQueryClient } from '@tanstack/react-query';
import { findActionIn, invokeAction } from 'actions';
import { useAuthStatus } from 'features/auth';
import { invalidateProjectLists, removeProjectDetail } from './queries';
/** Shared mutationKey so consumers can detect in-flight removes via `useIsMutating`. */
export const REMOVE_DL_PROJECT_KEY = ['removeDLProject'];
export function useRemoveDLProject() {
    const authStatus = useAuthStatus();
    const user = authStatus.kind === 'authenticated' ? authStatus.user : null;
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: [...REMOVE_DL_PROJECT_KEY],
        mutationFn: async ({ project }) => {
            if (!user)
                throw new Error('not authenticated');
            const action = findActionIn(project.potentialAction, 'remove');
            if (!action)
                throw new Error('remove action unavailable for this project');
            if (!project.id)
                throw new Error('project.id missing');
            const response = await invokeAction(action, user.token, {
                body: { object: project.id },
            });
            if (!response.ok)
                throw new Error(`removeDLProject returned ${response.status}`);
        },
        onSuccess: (_data, { project }) => {
            if (project.UUID && user?.email) {
                removeProjectDetail(queryClient, user.email, project.UUID);
            }
            // Mark the lists stale explicitly — the global staleTime means the
            // mount-refetch on navigating back would otherwise serve cached data
            // still containing the deleted project.
            invalidateProjectLists(queryClient, user?.email);
        },
    });
}
